import { Model } from 'modules/core/lib/mobx-rest'

const Names = {
  target: 'target',
  peers: 'peers',
}

class Group extends Model {
  static urlRoot() {
    return '/surveys/groups'
  }

  static Names = Names

  get indexes() {
    return ['name', 'access_group_id']
  }
}

export default Group
